"use strict";
var React = require("react");
var Link = require("react-router").Link;
var CompanyStore = require("../../stores/CompanyStore");
var AuthenticationStore = require("../../stores/AuthenticationStore");
var _ = require("underscore");

var Settings = React.createClass({
    getInitialState() {
        var authState = AuthenticationStore.getState();
        return {
          is_staff: authState.is_staff
        };
    },
    componentWillMount: function() {
        AuthenticationStore.listen(this.onAuthChange);
    },
    componentWillUnmount: function() {
        AuthenticationStore.unlisten(this.onAuthChange);
    },
    onAuthChange: function(state) {
      this.setState({
        is_staff: state.is_staff
      });
    },
    render: function() {
        return (
            <div className="content_section">
              <div id="subheader">
                <h1 className="subheader-title">Kerfisstillingar</h1>
              </div>
              <div className="settings-container">
                <div className="row content_section margin_subnav">
                  <div className="col-xs-12 paper">
                    {(this.state.is_staff) ?
                      <div className="row">
                        <div className="col-sm-4 col-md-3">
                          <div className="row">
                            <ul className="tab-menu">
                              <li><Link to="/settings/users" activeClassName="active" id="users"><span className="md md-account-box"></span><p>Notendur</p></Link></li>
                              <li><Link to="/settings/departments" activeClassName="active" id="departments"><span className="md md-account-balance"></span><p>Deildir</p></Link></li>
                              <li><Link to="/settings/locations" activeClassName="active" id="locations"><span className="md md-location-city"></span><p>Staðsetningar</p></Link></li>
                              <li><Link to="/settings/types" activeClassName="active" id="types"><span className="md md-collections"></span><p>Tegundir</p></Link></li>
                              <li><Link to="/settings/roles" activeClassName="active" id="roles"><span className="md md-star"></span><p>Hlutverk</p></Link></li>
                              <li><Link to="/settings/brands" activeClassName="active" id="brands"><span className="md md-label-outline"></span><p>Vörumerki</p></Link></li>
                              <li><Link to="/settings/import" activeClassName="active" id="import"><span className="md md-cloud-upload"></span><p>Innflutningur gagna</p></Link></li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-sm-8 col-md-9 settings-content">
                          {this.props.children || "Kerfisstillingar"}
                        </div>
                      </div> :
                      <div className="text-center">
                        <h2>Þú hefur ekki aðgang að þessum hluta kerfisins.</h2>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
        );
    }
});


module.exports = Settings;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Settings.react.js